import isEmpty from 'lodash/isEmpty';
import WidgetWrapper from '../../wrapper/WidgetWrapper';
import dom from '../../wrapper/DomWrapper';
import FacebookPage from './FacebookPage';

class Facebook extends WidgetWrapper {
  init = () => {
    const elFacebookWidgetList = dom.getCollection(this.selector);

    if (isEmpty(elFacebookWidgetList)) return;

    elFacebookWidgetList.forEach((element) => {
      if (element) {
        const widget = new FacebookPage(element);
        widget.init();
      }
    });
  };
}

export default Facebook;
